export const SEARCH_TABLE_QUERY_KEY = 'search'
export const MAIN_TABLE_QUERY_KEY = 'main'
export const DOCUMENTS_QUERY_KEY = 'documents'
export const LIST_QUERY_KEY = 'list'
export const DETAIL_QUERY_KEY = 'detail'
export const PROJECT_MEMBERS_QUERY_KEY = 'project-members'
export const COMPARISON_LIST_QUERY_KEY = 'comparison-list'
export const COMPARISON_DATA_QUERY_KEY = 'comparison-data'
export const USER_ASSIGNMENTS = 'user-assignments'
export const USAGE_DASHBOARD = 'usage-dashboard'
export const FOLDERS_QUERY_KEY = 'folders'
export const PROJECT_QUERY_KEY = 'project'
export const PROJECTS_QUERY_KEY = 'projects'
